import React, {Component} from  "react";
import { connect } from "react-redux";
import {updateAppPosition, updateAppClickTime} from '../../action/morpheus.state.action'

import "../../asset/style/utils/draggable.css"

class Draggable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            moved: false
        }

        this.oldPosX = 0;
        this.oldPosY = 0;
        this.newPosX = 0;
        this.newPosY = 0;

        this.startTop = this.props.startTop >= 100 ? 20 : this.props.startTop;
        this.startLeft = this.props.startLeft >= 100 ? 20 : this.props.startLeft;

        this.finalPosX = this.startLeft;
        this.finalPosY = this.startTop;
        this.props.dispatch(updateAppPosition(this.props.id, {
            x: this.finalPosX,
            y: this.finalPosY
        }, this.props.appState))
    }

    onMouseDown = (e) => {
        e = e || window.event;
        e.preventDefault();
        
        this.newPosX = e.clientX;
        this.newPosY = e.clientY;
        document.onmouseup = this.closeDragElement;
        document.onmousemove = this.elementDrag;
        this.setState({
            moved: true
        })
    }

    onTouchStart = (e) => {
        e = e || window.event;
        e.preventDefault();
        
        this.newPosX = e.touches[0].pageX;
        this.newPosY = e.touches[0].pageY;
        document.ontouchend = this.closeDragElement;
        document.ontouchmove = this.elementTouchDrag;
        this.setState({
            moved: true
        })
    }

    elementTouchDrag = (e) => {
        e = e || window.event;
        e.preventDefault();
        
        this.oldPosX = this.newPosX - e.touches[0].pageX;
        this.oldPosY = this.newPosY - e.touches[0].pageY;
        this.newPosX = e.touches[0].pageX;
        this.newPosY = e.touches[0].pageY;

        let clientHeight = document.documentElement.scrollHeight;
        let clientWidth = document.documentElement.clientWidth;
        
        this.finalPosY = (this.currentElement.offsetTop - this.oldPosY) * 100 / clientHeight;
        this.finalPosX = (this.currentElement.offsetLeft - this.oldPosX) * 100 / clientWidth;
        
        let maxAllowedY = (clientHeight - this.currentElement.clientHeight) * 100 / clientHeight;
        let maxAllowedX = (clientWidth - this.currentElement.clientWidth) * 100 / clientWidth;

        this.finalPosX = Math.min(maxAllowedX, this.finalPosX);
        this.finalPosY = Math.min(maxAllowedY, this.finalPosY);
        this.finalPosX = Math.max(0, this.finalPosX);
        this.finalPosY = Math.max(0, this.finalPosY);

        this.currentElement.style.top = (this.finalPosY) + "%";
        this.currentElement.style.left = (this.finalPosX) + "%";
    }
    
    elementDrag = (e) => {
        e = e || window.event;
        e.preventDefault();
        
        this.oldPosX = this.newPosX - e.clientX;
        this.oldPosY = this.newPosY - e.clientY;
        this.newPosX = e.clientX;
        this.newPosY = e.clientY;

        let clientHeight = document.documentElement.clientHeight;
        let clientWidth = document.documentElement.clientWidth;

        this.finalPosY = (this.currentElement.offsetTop - this.oldPosY) * 100 / clientHeight;
        this.finalPosX = (this.currentElement.offsetLeft - this.oldPosX) * 100 / clientWidth;
        
        let maxAllowedY = (clientHeight - this.currentElement.clientHeight) * 100 / clientHeight;
        let maxAllowedX = (clientWidth - this.currentElement.clientWidth) * 100 / clientWidth;

        this.finalPosX = Math.min(maxAllowedX, this.finalPosX);
        this.finalPosY = Math.min(maxAllowedY, this.finalPosY);
        this.finalPosX = Math.max(0, this.finalPosX);
        this.finalPosY = Math.max(0, this.finalPosY);

        this.currentElement.style.top = (this.finalPosY) + "%";
        this.currentElement.style.left = (this.finalPosX) + "%";
    }
    
    closeDragElement = () => {
        this.props.dispatch(updateAppPosition(this.props.id, {
            x: this.finalPosX,
            y: this.finalPosY
        }, this.props.appState));
        document.onmouseup = null;
        document.ontouchend = null;
        document.onmousemove = null;
        document.ontouchmove = null;
    }

    componentDidMount = () => {
        this.currentElement = document.getElementById(this.props.id);
    }

    componentWillUnmount = () => {
        this.oldPosX = 0;
        this.oldPosY = 0;
        this.newPosX = 0;
        this.newPosY = 0;
        this.closeDragElement();
        this.setState({
            moved: false
        })
    }

    render(){
        let calculatedZIndex;
        try {
            calculatedZIndex = (this.props.appState[this.props.id] || {}).zIndex;
        } catch (err) {
            calculatedZIndex = 9;
        }

        return (
            <div 
                onMouseDown={() => this.props.dispatch(updateAppClickTime(this.props.id))}
                id={this.props.id}
                style={{top: this.startTop + "%", left: this.startLeft + "%", zIndex: calculatedZIndex}} 
                className={"draggable"}>
                <div 
                    className="draggable-handle" 
                    onMouseDown={this.onMouseDown}
                    onTouchStart={this.onTouchStart}>
                </div>
                {this.props.content}
            </div>
        )
    }
}

const mapStateToProps = state => {
  return {
    appState: state.viewerUrlReducer.app_state,
  };
};

export default connect(mapStateToProps)(Draggable);
